"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGridConfigurationForScreenSize = exports.ENABLE_SYMMETRICAL_SPECIAL_COLOR = exports.POST_SWEEP_FLOWER_DELAY_DURATION = exports.STAMP_CHANCE = exports.MOBILE_IMAGE_URL = exports.DESKTOP_IMAGE_URL = exports.BASE_SPECIAL_COLOR_PREFERENCE_CHANCE = exports.ADDITIONAL_FLOWER_CREATION_DELAY_MS = exports.INITIAL_CURSOR_VISIBILITY_DELAY_MS = exports.PALETTE_SATURATION_LIGHTNESS_ADJUST = exports.PALETTE_SATURATION_STEP = exports.PALETTE_SATURATION_INTERVAL_MS = exports.MIN_COLOR_VARIETY_PROXIMITY = exports.MAX_FILL_RATIO_PROXIMITY_BOOST = exports.MIN_FILL_RATIO_PROXIMITY = exports.MAX_PATTERN_DIMENSION_PROXIMITY_BOOST = exports.MIN_PATTERN_DIMENSION_PROXIMITY = exports.MAIN_CURSOR_PROXIMITY_FAR_THRESHOLD_PX = exports.MAIN_CURSOR_PROXIMITY_CLOSE_THRESHOLD_PX = exports.numberOfMockUsers = exports.MOCK_CURSOR_MAX_CONTROL_POINT_OFFSET_PIXELS = exports.MOCK_CURSOR_MOVEMENT_DURATION_VARIATION_MS = exports.MOCK_CURSOR_MOVEMENT_DURATION_MS_BASE = exports.MOCK_CURSOR_COLORS = exports.CLICK_CURSOR_COLORS = exports.DEFAULT_PALETTE = exports.MANUAL_EIGHT_COLOR_PALETTE = exports.CONNECTED_CURSOR_HIGHLIGHT_COLOR = exports.DEFAULT_GRID_HIGHLIGHT_COLOR = exports.SPECIAL_COLOR = exports.SWEEP_LINE_COLOR = exports.SWEEP_PAUSE_DURATION_MS = exports.SWEEP_DURATION_MS = exports.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS = exports.ANIMATION_STEP_DURATION = exports.MOCK_BOT_FLOWER_CHANCE = exports.MOUSE_MOVE_FLOWER_SAMPLE_RATE = exports.TARGET_FLOWERS_VERTICALLY = exports.TARGET_FLOWERS_HORIZONTALLY = exports.PATTERN_DIMENSION = exports.CLICK_MAX_FILLED_CELL_RATIO = exports.MAX_FILLED_CELL_RATIO = void 0;
exports.MAX_FILLED_CELL_RATIO = 0.15;
exports.CLICK_MAX_FILLED_CELL_RATIO = 0.6; // New: For click-generated flowers
exports.PATTERN_DIMENSION = 5;
exports.TARGET_FLOWERS_HORIZONTALLY = 8;
exports.TARGET_FLOWERS_VERTICALLY = 4;
exports.MOUSE_MOVE_FLOWER_SAMPLE_RATE = 0.05;
exports.MOCK_BOT_FLOWER_CHANCE = 0.1;
exports.ANIMATION_STEP_DURATION = 90; // ms per new ring
exports.FLOWER_GRID_CELL_WIDTH_IN_SEGMENTS = (2 * exports.PATTERN_DIMENSION - 1);
exports.SWEEP_DURATION_MS = 2000;
exports.SWEEP_PAUSE_DURATION_MS = 10000;
exports.SWEEP_LINE_COLOR = 'rgba(192, 192, 192, 0.7)';
exports.SPECIAL_COLOR = "#99cbdb"; // This remains for UI elements and special effects
exports.DEFAULT_GRID_HIGHLIGHT_COLOR = 'rgba(200, 200, 200, 0.7)'; // Grey for unconnected
exports.CONNECTED_CURSOR_HIGHLIGHT_COLOR = exports.SPECIAL_COLOR; // Special color for connected highlights and lines
// Manually defined 8-color palette
exports.MANUAL_EIGHT_COLOR_PALETTE = [
    '#99cbdb',
    '#4B5E56',
    '#334224',
    '#7C6D4C',
    '#4C4047',
    '#32342F',
    '#4C4047',
    '#32342F',
];
exports.DEFAULT_PALETTE = __spreadArray([], exports.MANUAL_EIGHT_COLOR_PALETTE, true);
exports.CLICK_CURSOR_COLORS = __spreadArray(__spreadArray([], exports.MANUAL_EIGHT_COLOR_PALETTE, true), [exports.SPECIAL_COLOR, exports.SPECIAL_COLOR, exports.SPECIAL_COLOR], false); // New palette for clicks
exports.MOCK_CURSOR_COLORS = [
    exports.SPECIAL_COLOR // Mock cursors also use the special color
];
// Config for realistic mock cursor movement
exports.MOCK_CURSOR_MOVEMENT_DURATION_MS_BASE = 700; // Base duration for a movement segment
exports.MOCK_CURSOR_MOVEMENT_DURATION_VARIATION_MS = 300; // Max +/- variation from base
exports.MOCK_CURSOR_MAX_CONTROL_POINT_OFFSET_PIXELS = 50; // Max offset for Bezier control point
exports.numberOfMockUsers = 2; // Fixed number of mock users
// Config for main cursor proximity effects
exports.MAIN_CURSOR_PROXIMITY_CLOSE_THRESHOLD_PX = 100;
exports.MAIN_CURSOR_PROXIMITY_FAR_THRESHOLD_PX = 350;
exports.MIN_PATTERN_DIMENSION_PROXIMITY = 4; // Smallest flower size when far
exports.MAX_PATTERN_DIMENSION_PROXIMITY_BOOST = 2; // Added to PATTERN_DIMENSION from slider when close
exports.MIN_FILL_RATIO_PROXIMITY = 0.2; // Least filled when far
exports.MAX_FILL_RATIO_PROXIMITY_BOOST = 0.0; // Added to MAX_FILLED_CELL_RATIO from slider when close
exports.MIN_COLOR_VARIETY_PROXIMITY = 2; // Minimum number of distinct colors when far (from the 8 available)
// Palette Saturation Configuration
exports.PALETTE_SATURATION_INTERVAL_MS = 500;
exports.PALETTE_SATURATION_STEP = 0.06; // Increase in HSL saturation (0-1 scale)
exports.PALETTE_SATURATION_LIGHTNESS_ADJUST = 0.02; // Adjustment to HSL lightness (0-1 scale)
// Initial Load Delays
exports.INITIAL_CURSOR_VISIBILITY_DELAY_MS = 1000; // Delay before mock cursors appear
exports.ADDITIONAL_FLOWER_CREATION_DELAY_MS = 1000; // Additional delay after cursors appear before flowers can be made
// Special Color Preference
exports.BASE_SPECIAL_COLOR_PREFERENCE_CHANCE = 0.5;
// Image URLs
exports.DESKTOP_IMAGE_URL = "https://jonnyscholes-production.s3.amazonaws.com/images/background.original.jpg";
exports.MOBILE_IMAGE_URL = "https://jonnyscholes-production.s3.amazonaws.com/images/background-mobile.original.jpg";
// New constants for removed UI controls
exports.STAMP_CHANCE = 0.8;
exports.POST_SWEEP_FLOWER_DELAY_DURATION = 1000;
exports.ENABLE_SYMMETRICAL_SPECIAL_COLOR = false;
function updateGridConfigurationForScreenSize() {
    var isMobilePortrait = window.innerWidth < 768 && window.innerHeight > window.innerWidth;
    if (isMobilePortrait) {
        exports.TARGET_FLOWERS_HORIZONTALLY = 4;
        exports.TARGET_FLOWERS_VERTICALLY = 6;
    }
    else {
        exports.TARGET_FLOWERS_HORIZONTALLY = 8;
        exports.TARGET_FLOWERS_VERTICALLY = 4;
    }
    return isMobilePortrait;
}
exports.updateGridConfigurationForScreenSize = updateGridConfigurationForScreenSize;
